import React from "react";
import { EvaluationProvider } from "../stores/EvaluationContext";
import { CatalogProvider } from "../stores/CatalogContext";
import AcrEditor from "../pages/AcrEditor";

/** Layout wrapper: providers + AcrEditor. Child routes live in RouterShell and render in AcrEditor’s Outlet. */
export default function EditorRoutes() {
  return (
    <EvaluationProvider>
      <CatalogProvider>
        <AcrEditor />
      </CatalogProvider>
    </EvaluationProvider>
  );
}

export function AcrEditorHome() {
  return (
    <div>
      <h2>ACR Editor</h2>
      <p>Use the nav above or go to /acr-editor/chapter/success_criteria_level_a to open a chapter.</p>
    </div>
  );
}
